module.exports = __webpack_public_path__ + "media/SWV-I_Gruppendiagnose_4_Falsche_Reihenfolge_der_Stellenwerte.1eee8554.mp3";